import React, { useState, useEffect } from 'react';
import HeadingBlock from '../common/heading';
import illustration from './../../assets/popupicon.svg'
import star from './../../assets/star.svg'
import close1 from './../../assets/close.svg'
import { supabase } from '../../supabase';

import '../common/button.css';
import Button from '../common/button';

const PopUp = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [selectedRating, setSelectedRating] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 8000);

        return () => clearTimeout(timer);
    }, []);

    if (!isVisible) return null;

    const handleSubmit = async () => {
        if (!selectedRating) return;
        const { error } = await supabase
            .from('feedback')
            .insert([{ stars: selectedRating }]);

        if (!error) {
            setSubmitted(true);
            setTimeout(() => setIsVisible(false), 1500);
        } else {
            console.error('Error submitting feedback:', error);
        }
    };

    return (
        <div className="popUp">
            <button onClick={() => setIsVisible(false)} className='size1 beige closeBtn'>
                <img src={close1} alt="" />
            </button>
            <div className="popUpMsg">
                <img className='popupicon' src={illustration} alt="" />
                <HeadingBlock 
                    heading="Give Us a Rating!"
                    subheading="Tell us what you think of our app"
                    style1="light center wrapped"
                />

                <div className="rating">
                    {[5, 4, 3, 2, 1].map((val) => (
                        <React.Fragment key={val}>
                            <input
                                type="radio"
                                id={`star${val}`}
                                name="rating"
                                value={val}
                                onChange={() => setSelectedRating(val)}
                            />
                            <label htmlFor={`star${val}`} className="fa fa-star" />
                        </React.Fragment>
                    ))}
                </div>

                {submitted ? (
                    <p style={{ marginTop: 21 }}>Thanks for your feedback!</p>
                ) : (
                    <div className="btnFlex">
                        <button
                        className="size1 blue"
                        onClick={handleSubmit}
                        disabled={!selectedRating}
                    >
                        <img src={star} alt="" />
                        <h6>Submit Feedback</h6>
                        <img src={star} alt="" />
                    </button>
                     <button className="size1 beige" onClick={() => setIsVisible(false)} >
                    <h6>Close</h6>
                </button>
                    </div>
                )}

                
            </div>          
        </div>
    );
}

export default PopUp;